module.exports = "/images/modal-close.svg";